import { storeCodeSchema } from 'schema/storeCode';
import { z } from 'zod';

export const welcomeKitMetafieldsUpdatePathSchema = z.object({
  store: storeCodeSchema
});

export const welcomeKitMetafieldsUpdateKeys = z.enum(['welcomeKit', 'otpTp']);

export const welcomeKitMetafieldsUpdateMetafield = z.object({
  id: z.string().nullish(),
  value: z.string().nullish(),
  type: z.string().nullish(),
  key: welcomeKitMetafieldsUpdateKeys.nullish()
});

export const welcomeKitMetafieldsUpdateBodySchema = z.object({
  customerId: z.string(),
  metafields: z.array(welcomeKitMetafieldsUpdateMetafield)
});
